import '../Index/Index.scss'

import React, {Component} from 'react'
import { Button, Modal } from 'react-bootstrap'

import { RQ_STATUS_STARTED, RQ_STATUS_FINISHED, RQ_STATUS_FAILED, BROKER_REMOVED_REASON_DEPARTING, BROKER_REMOVED_REASON_OPT_OUT } from 'common/constants'
import {
  fetchAccount,
  removeAgent,
  fetchAgentDepartureAgreement,
  checkJobStatus,
  editAgentMVIPEnabled
} from 'broker/redux/account'
import {
  selectCompletedAgents, selectIsTransitionBrokerage,
} from 'broker/selectors/account'
import { selectAuthUser } from 'common/redux/selectors/auth'
import { connect } from 'react-redux'

class RemoveAgent extends Component {

    constructor(props) {
        super(props)
        this.state = { modal_state: this.getInitialModalState() }
        this.getModalComponents = this.getModalComponents.bind(this)
        this.handleDeparting = this.handleDeparting.bind(this)
        this.handleOptOut = this.handleOptOut.bind(this)
        this.handleDisableAgent = this.handleDisableAgent.bind(this)
        this.handleDownload = this.handleDownload.bind(this)
        this.handleRemoveLastMVIPAgent= this.handleRemoveLastMVIPAgent.bind(this)
    }

    getInitialModalState() {
      let modalState = 'default'
      if(this.props.agent.is_mvip_participant && this.getMVIPAgentCount() == 1 && this.props.is_transition_brokerage) {
        modalState = this.props.user.is_masquerade ? 'last-mvip-agent-internal' : 'last-mvip-agent-external'
      }
      return modalState
    }

    getMVIPAgentCount() {
      let count = 0
       this.props.completed_agents.forEach(agent => {
         if(agent.is_mvip_participant) {
           count += 1
         }
      })
      return count
    }

    handleDeparting() {
        this.setState({
            modal_state: 'confirm_disable',
            pretty_reason: 'Left Our Brokerage',
            reason: BROKER_REMOVED_REASON_DEPARTING
        })
    }

    handleOptOut() {
        this.setState({
            modal_state: 'confirm_disable',
            pretty_reason: 'No Longer Interested',
            reason: BROKER_REMOVED_REASON_OPT_OUT
        })
    }

    handleDisableAgent() {
        this.setState({ modal_state: 'disabled' })
        this.props.dispatch(removeAgent(this.props.agent.id, this.state.reason, this.state.comment))
            .then(() => (this.props.dispatch(fetchAccount())))
    }

    handleRemoveLastMVIPAgent() {
      if(this.props.can_remove) {
        this.setState({ modal_state: 'default' })
      } else {
        this.props.dispatch(editAgentMVIPEnabled(false, this.props.agent.id))
        this.props.handleHide()
      }
    }

    handleDownload() {
        this.setState({ downloading: true })
        this.props.dispatch(fetchAgentDepartureAgreement(this.props.agent.id))
            .then((response) => {
                if (response.url) {
                    this.setState({ downloading: false })
                    window.open(response.url, '_blank')
                } else {
                    this.pollJobStatus(response.queue, response.job_id)
                }
            })
            .catch((error) => this.setState({ error: true }))
    }

    pollJobStatus(queue, job_id) {
        setTimeout(() => {
            this.props.dispatch(checkJobStatus(queue, job_id))
                .then((response) => {
                    if (response.status === RQ_STATUS_STARTED) {
                        this.setState({ downloading: true })
                        this.pollJobStatus(queue, job_id)
                    } else if (response.status === RQ_STATUS_FINISHED) {
                        this.setState({ downloading: false })
                        window.open(response.result, '_blank')
                    } else if (response.status === RQ_STATUS_FAILED) {
                        this.setState({ downloading: false, error: true })
                    } else {
                        this.setState({ downloading: true })
                        this.pollJobStatus(queue, job_id)
                    }
                })
        }, 1000)
    }

    getModalComponents(agent) {
        let header, body
        switch (this.state.modal_state) {

            case 'default':
                header = <Modal.Header className="RemoveAgentModal__default-header">
                    <Modal.Title>Why are you disabling this agent?</Modal.Title>
                </Modal.Header>

                body = <Modal.Body>
                    <div className="RemoveAgentModal__disable-options">
                        <div>
                            <div className="RemoveAgentModal__disable-options__img-door"></div>
                            <p>This agent is planning to depart your brokerage (or has already departed).</p>
                            <Button onClick={this.handleDeparting}>Left our brokerage</Button>
                        </div>
                        <div>
                            <div className="RemoveAgentModal__disable-options__img-hand"></div>
                            <p>This agent is still registered with your brokerage, but has requested to opt-out of the Opcity program.</p>
                            <Button onClick={this.handleOptOut}>No Longer Interested</Button>
                        </div>
                    </div>
                </Modal.Body>
                break
            case 'last-mvip-agent-internal':
                header = <Modal.Header className="RemoveAgentModal__default-header">
                    <Modal.Title>Disable Last Market VIP Enabled Agent</Modal.Title>
                </Modal.Header>

                body = <Modal.Body>
                    <div className="RemoveAgentModal__disabled">
                        <div className="RemoveAgentModal__disabled__summary">
                          <p>This agent is the last Market VIP enabled agent.</p>
                          <p>Are you sure you want to continue? This could prevent a Market VIP Launch.</p>
                        </div>
                      <div className="RemoveAgentModal__confirm-disable__button">
                        <Button bsStyle="danger" onClick={this.handleRemoveLastMVIPAgent}>Confirm</Button>
                      </div>
                    </div>
                </Modal.Body>
                break
            case 'last-mvip-agent-external':
                header = <Modal.Header className="RemoveAgentModal__default-header">
                    <Modal.Title>Disable Last Market VIP Enabled Agent</Modal.Title>
                </Modal.Header>

                body = <Modal.Body>
                    <div className="RemoveAgentModal__disabled">
                        <div className="RemoveAgentModal__disabled__summary">
                          <p>This is the last Market VIP agent you have enabled. Please add another Market VIP enabled
                            agent before disabling this one or contact Broker Support if you need more help.</p>
                        </div>
                    </div>
                </Modal.Body>
                break

            case 'confirm_disable':
                header = <Modal.Header className="RemoveAgentModal__confirm-disable__header">
                    <Modal.Title>Confirm Disable Agent</Modal.Title>
                </Modal.Header>

                body = <Modal.Body className="RemoveAgentModal__confirm-disable">
                    <div className="RemoveAgentModal__confirm-disable__details">
                        <div>Disable Agent:</div>
                        <span>{agent.name}</span>
                    </div>

                    <div className="RemoveAgentModal__confirm-disable__details">
                        <div>Reason:</div>
                        <span>{this.state.pretty_reason}</span>
                    </div>

                    <div className="RemoveAgentModal__confirm-disable__input-section">
                        <div>(Optional) Is there anything we could have done to improve this agent's experience?</div>
                        <textarea value={this.state.comment} onChange={(e) => this.setState({ comment: e.target.value })}></textarea>
                    </div>

                    <div className="RemoveAgentModal__confirm-disable__button">
                        <Button bsStyle="danger" onClick={this.handleDisableAgent}>Disable Agent</Button>
                    </div>
                </Modal.Body>
                break

            case 'disabled':
                header = <Modal.Header className="RemoveAgentModal__disabled__header">
                    <Modal.Title>Agent Disabled</Modal.Title>
                </Modal.Header>

                let downloadSection
                if (!this.state.error) {
                    downloadSection = !this.state.downloading ? <Button bsStyle="primary" onClick={this.handleDownload}>Download Departure Agreement</Button> : <p>Downloading <i className="fa fa-circle-o-notch rotating" aria-hidden="true" /></p>
                } else {
                    downloadSection = <p className="error-text"><i className="fa fa-exclamation-circle" /> Error: Please refresh the page and try again.</p>
                }


                body = <Modal.Body className="RemoveAgentModal__disabled">
                    <div className="RemoveAgentModal__disabled__summary">
                        <div>{agent.name}</div>
                        <div className="RemoveAgentModal__disabled__summary__text">Agent is disabled</div>
                    </div>

                    <p>
                        <strong>A reminder:</strong> even though this agent is no longer participating in the Opcity network, your brokerage is still
                  <strong> responsible</strong> for paying fees related to any and all transactions that occur in the next 24 months with referrals
                  Opcity sent to the agent.
                </p>

                    <p>
                        To help ensure agent compliance (and get you the fees you deserve) we <strong>strongly recommend</strong> that you get the agent to <strong>sign
                  the enclosed Departure Agreement.</strong> It outlines the agent's payment obligations and includes a list of open Opcity referrals.
                </p>

                    <div className="RemoveAgentModal__disabled__button">
                        {downloadSection}
                        <p>You can also access the Departure Agreement from your list of agents.</p>
                    </div>
                </Modal.Body>
                break
        }
        return {
            header,
            body
        }
    }

    render() {
        const { agent } = this.props
        const layout = this.getModalComponents(agent)
        return (
            <Modal className="RemoveAgentModal" show={this.props.show}>
                {layout.header}
                {layout.body}
                <Modal.Footer>
                    <Button onClick={this.props.handleHide}>Close</Button>
                </Modal.Footer>
            </Modal>)
    }
}
const mapStateToProps = state => ({
  completed_agents: selectCompletedAgents(state),
  user: selectAuthUser(state),
  is_transition_brokerage: selectIsTransitionBrokerage(state)
})
const mapDispatchToProps = dispatch => ({
  dispatch
})
export default connect(mapStateToProps, mapDispatchToProps)(RemoveAgent)
